// src/pages/SignupAcademy.js
import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import "../css/SignupAcademy.css";
import axios from "axios";

const games = [
  { id: 1, slug: "cs2",            title: "Counter-Strike 2" },
  { id: 2, slug: "valorant",       title: "Valorant" },
  { id: 3, slug: "lol",            title: "League of Legends" },
  { id: 4, slug: "fortnite",       title: "Fortnite" },
  { id: 5, slug: "pubg",           title: "Battlegrounds" },
  { id: 6, slug: "tft",            title: "Team Fight Tactics" },
  { id: 7, slug: "fifa",           title: "FIFA 25" },
  { id: 8, slug: "robloxminecraft",title: "Roblox / Minecraft" },
];

const days = [
  { id: 1, name: "Mandag" },
  { id: 2, name: "Tirsdag" },
  { id: 3, name: "Onsdag" },
  { id: 4, name: "Torsdag" },
  { id: 5, name: "Fredag" },
  { id: 6, name: "Lørdag" },
  { id: 7, name: "Søndag" },
];

const STEPS = [
  { number: 1, label: "Info" },
  { number: 2, label: "Hold" },
  { number: 3, label: "Personlig" },
  { number: 4, label: "Forældre" },
  { number: 5, label: "Bekræft" },
];

const calculateAge = (birthDate) => {
  if (!birthDate) return 0;
  const today = new Date();
  const birth = new Date(birthDate);
  let age = today.getFullYear() - birth.getFullYear();
  const monthDiff = today.getMonth() - birth.getMonth();
  if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birth.getDate())) age--;
  return age;
};

const isCS2 = (form) =>
  Number(form.game_id) === 1 || form.game_name === "Counter-Strike 2";

const SignupAcademy = () => {
  const location = useLocation();
  const [step, setStep] = useState(1);
  const [signupSuccess, setSignupSuccess] = useState(false);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [steamUser, setSteamUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState("");
  const [personalId, setPersonalId] = useState("");
  const [acceptTerms, setAcceptTerms] = useState(false);
  const [confirmAge, setConfirmAge] = useState(false);

  const [form, setForm] = useState({
    name: "", email: "", phone: "", birthDate: "",
    address: "", postal_code: "", city: "", country: "",
    parent_name: "", parent_email: "", parent_phone: "",
    ingame_name: "", game_id: "", game_name: "",
    training_time: "", day_id: "", day_name: "", level: ""
  });

  // Indlæs gemt holdvalg + ingame_name
  useEffect(() => {
    const saved = JSON.parse(localStorage.getItem("academy_selection") || "{}");
    const merged = { ...saved, ...(location.state || {}) };
    const gameId = Number(merged.game_id);
    const dayId  = Number(merged.day_id);
    const game   = games.find(g => g.id === gameId);
    const day    = days.find(d => d.id === dayId);
    setForm(prev => ({
      ...prev, ...merged,
      game_id:   gameId || "",
      day_id:    dayId  || "",
      game_name: game?.title || merged.game_name || "",
      day_name:  day?.name   || "",
      ingame_name: merged.ingame_name || prev.ingame_name || "",
    }));
  }, [location.state]);

  // Gendan step efter Steam-redirect
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    if (params.get("steam") === "success") {
      const savedStep = localStorage.getItem("academy_step");
      if (savedStep) setStep(Number(savedStep));
    }
  }, []);

  // Opdater game/day navne når id ændres
  useEffect(() => {
    const game = games.find(g => g.id === Number(form.game_id));
    const day  = days.find(d => d.id === Number(form.day_id));
    setForm(prev => ({
      ...prev,
      game_name: game?.title || "",
      day_name:  day?.name   || "",
    }));
  }, [form.game_id, form.day_id]);

  // Gem holdvalg + ingame_name i localStorage
  useEffect(() => {
    const selectionOnly = {
      game_id: form.game_id, game_name: form.game_name,
      training_time: form.training_time, day_id: form.day_id,
      day_name: form.day_name, level: form.level,
      ingame_name: form.ingame_name,
    };
    localStorage.setItem("academy_selection", JSON.stringify(selectionOnly));
  }, [form.game_id, form.game_name, form.training_time, form.day_id, form.day_name, form.level, form.ingame_name]);

  // Gem step så det overlever Steam-redirect
  useEffect(() => {
    localStorage.setItem("academy_step", String(step));
  }, [step]);

  // Tjek Discord login
  useEffect(() => {
    axios.get("https://linxlegacyacademy.dk/auth/user", { withCredentials: true })
      .then(res => setIsAuthenticated(res.data.status === "logged_in"))
      .catch(() => setIsAuthenticated(false))
      .finally(() => setLoading(false));
  }, []);

  // Tjek Steam login
  useEffect(() => {
    fetch("/auth/steam/me", { credentials: "include" })
      .then(r => r.json())
      .then(data => { if (!data.error) setSteamUser(data); })
      .catch(() => {});
  }, []);

  // Redirect til Discord efter signup
  useEffect(() => {
    if (!signupSuccess) return;
    setMessage("Tilmelding gennemført 🎉 Du bliver sendt til Discord...");
    const timer = setTimeout(() => {
      window.location.href = "https://discord.com/invite/cWUtWdThXu";
    }, 3000);
    return () => clearTimeout(timer);
  }, [signupSuccess]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage("");
    setPersonalId("");
    try {
      const res = await axios.post(
        "https://linxlegacyacademy.dk/api/academy/signup",
        { ...form, steamid: steamUser?.steamid ?? null },
        { withCredentials: true }
      );
      if (res.data.status === "success") {
        setPersonalId(res.data.personal_id);
        setMessage(`Tilmelding gennemført! Dit ID: ${res.data.personal_id} 🎉`);
        setSignupSuccess(true);
        localStorage.removeItem("academy_selection");
        localStorage.removeItem("academy_step");
      } else {
        setMessage(res.data.error || "Fejl");
      }
    } catch (err) {
      setMessage(err.response?.data?.error || "Fejl ved signup");
    }
  };

  if (loading) return <p>Loader...</p>;

  const under18    = calculateAge(form.birthDate) < 18;
  const totalSteps = under18 ? 5 : 4;
  const next = () => setStep(s => Math.min(s + 1, totalSteps));
  const prev = () => setStep(s => Math.max(s - 1, 1));

  const effectiveSteps = under18
    ? STEPS
    : STEPS.filter(s => s.number !== 4).map((s, i) => ({ ...s, number: i + 1 }));

  const cs2MissingSteam = step === 2 && isCS2(form) && !steamUser;

  const getStepContent = () => {
    const logicalStep = under18 ? step : step >= 4 ? step + 1 : step;

    switch (logicalStep) {

      // ── Step 1: Velkommen ────────────────────────────────────────────────────
      case 1:
        return (
          <div className="step-content">
            <h2>Velkommen til Linx Academy</h2>
            <p className="step-desc">
              Få ugentlig træning, deltag i turneringer og bliv en del af et stærkt gaming-fællesskab.
            </p>

            <div className="benefits-grid">
              <div className="benefit-item"><span>🎮</span><p>Ugentlig træning med træner</p></div>
              <div className="benefit-item"><span>📈</span><p>Fællesskab og teamwork</p></div>
              <div className="benefit-item"><span>🏆</span><p>Turneringer og events</p></div>
              <div className="benefit-item"><span>💬</span><p>Aktivt community</p></div>
            </div>

            <div className="price-box">
              <p><strong>Pris:</strong> 2000 kr / halvår</p>
              <p>Første træning er gratis</p>
            </div>

            <div className="discord-connect">
              <button
                type="button"
                onClick={() => window.location.href = "/auth/discord/login?type=academy"}
                className={`btn-discord ${isAuthenticated ? "connected" : ""}`}
              >
                {isAuthenticated ? "✅ Discord forbundet" : "Login med Discord"}
              </button>
              {!isAuthenticated && (
                <p className="hint">Du skal logge ind med Discord for at fortsætte</p>
              )}
            </div>
          </div>
        );

      // ── Step 2: Vælg hold + Steam (CS2) ─────────────────────────────────────
      case 2:
        return (
          <div className="step-content">
            <h2>Vælg dit hold</h2>
            <p className="step-desc">Hvilken tid og spil passer dig bedst?</p>

            <div className="game-info-box">
              <div className="info-row"><span>Spil</span><strong>{form.game_name || "Ikke valgt"}</strong></div>
              <div className="info-row"><span>Dag</span><strong>{form.day_name  || "Ikke valgt"}</strong></div>
              <div className="info-row"><span>Tid</span><strong>{form.training_time || "Ikke valgt"}</strong></div>
              <div className="info-row"><span>Level</span><strong>{form.level   || "Ikke valgt"}</strong></div>
            </div>

            <a href="/Gametime" className="btn-secondary">Skift holdtid →</a>

            <div className="form-field">
              <label>Ingame navn</label>
              <input
                name="ingame_name"
                value={form.ingame_name}
                onChange={handleChange}
                placeholder="Dit in-game navn..."
              />
            </div>

            {/* Steam login — kun hvis CS2 er valgt */}
            {isCS2(form) && (
              <div className="discord-connect" style={{ marginTop: 24 }}>
                {steamUser ? (
                  <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
                    <img
                      src={steamUser.avatar}
                      alt={steamUser.username}
                      style={{ width: 36, height: 36, borderRadius: "50%" }}
                    />
                    <span>✅ Steam forbundet: <strong>{steamUser.username}</strong></span>
                    <button
                      type="button"
                      onClick={async () => {
                        await fetch("/auth/steam/logout", { credentials: "include" });
                        setSteamUser(null);
                      }}
                      style={{
                        fontSize: 12, color: "#8b92a8", marginLeft: 8,
                        background: "none", border: "none", cursor: "pointer", textDecoration: "underline"
                      }}
                    >
                      Skift konto
                    </button>
                  </div>
                ) : (
                  <>
                    <button
                      type="button"
                      onClick={() => {
                        window.location.href = "/auth/steam?return=/signup-academy";
                      }}
                      className="btn-discord"
                      style={{ background: "#1b2838", borderColor: "#2a3f5f", color: "#c7d5e0" }}
                    >
                      🎮 Login med Steam
                    </button>
                    <p className="hint">CS2 kræver Steam login for at tilmelde dig</p>
                  </>
                )}
              </div>
            )}
          </div>
        );

      // ── Step 3: Personlige oplysninger ───────────────────────────────────────
      case 3:
        return (
          <div className="step-content">
            <h2>Dine oplysninger</h2>
            <p className="step-desc">Udfyld dine personlige informationer.</p>

            <div className="form-grid">
              <div className="form-field">
                <label>Navn *</label>
                <input name="name" value={form.name} onChange={handleChange} required placeholder="Fulde navn" />
              </div>
              <div className="form-field">
                <label>Email *</label>
                <input name="email" type="email" value={form.email} onChange={handleChange} required placeholder="din@email.dk" />
              </div>
              <div className="form-field">
                <label>Telefon *</label>
                <input name="phone" value={form.phone} onChange={handleChange} required placeholder="+45 12 34 56 78" />
              </div>
              <div className="form-field">
                <label>Fødselsdato *</label>
                <input name="birthDate" type="date" value={form.birthDate} onChange={handleChange} required />
              </div>
              <div className="form-field full">
                <label>Adresse *</label>
                <input name="address" value={form.address} onChange={handleChange} required placeholder="Gadenavn 1" />
              </div>
              <div className="form-field">
                <label>Postnummer *</label>
                <input name="postal_code" value={form.postal_code} onChange={handleChange} required placeholder="1234" />
              </div>
              <div className="form-field">
                <label>By *</label>
                <input name="city" value={form.city} onChange={handleChange} required placeholder="København" />
              </div>
              <div className="form-field">
                <label>Land *</label>
                <input name="country" value={form.country} onChange={handleChange} required placeholder="Danmark" />
              </div>
            </div>
          </div>
        );

      // ── Step 4: Forældreinformation (kun under 18) ───────────────────────────
      case 4:
        return (
          <div className="step-content">
            <h2>Forældreinformation</h2>
            <p className="step-desc">Da du er under 18 år, skal vi bruge dine forældres oplysninger.</p>

            <div className="form-grid">
              <div className="form-field full">
                <label>Forældre navn</label>
                <input name="parent_name" value={form.parent_name} onChange={handleChange} placeholder="Forældrens fulde navn" />
              </div>
              <div className="form-field">
                <label>Forældre email</label>
                <input name="parent_email" type="email" value={form.parent_email} onChange={handleChange} placeholder="foraelder@email.dk" />
              </div>
              <div className="form-field">
                <label>Forældre telefon</label>
                <input name="parent_phone" value={form.parent_phone} onChange={handleChange} placeholder="+45 12 34 56 78" />
              </div>
            </div>
          </div>
        );

      // ── Step 5: Bekræft ──────────────────────────────────────────────────────
      case 5:
        return (
          <div className="step-content">
            <div className="step-icon">✅</div>
            <h2>Bekræft tilmelding</h2>
            <p className="step-desc">Gennemse dine oplysninger inden du sender.</p>

            <div className="confirm-grid">
              <div className="confirm-section">
                <h4>Hold</h4>
                <p>{form.game_name} — {form.day_name} {form.training_time}</p>
                <p>Level: {form.level}</p>
              </div>
              <div className="confirm-section">
                <h4>Personlige oplysninger</h4>
                <p>{form.name}</p>
                <p>{form.email}</p>
                <p>{form.phone}</p>
                <p>{form.address}, {form.postal_code} {form.city}</p>
              </div>
              {under18 && (
                <div className="confirm-section">
                  <h4>Forældre</h4>
                  <p>{form.parent_name}</p>
                  <p>{form.parent_email}</p>
                  <p>{form.parent_phone}</p>
                </div>
              )}
              <div className="confirm-section">
                <h4>Discord</h4>
                <p>{isAuthenticated ? "✅ Forbundet" : "❌ Ikke forbundet"}</p>
              </div>
              {isCS2(form) && (
                <div className="confirm-section">
                  <h4>Steam</h4>
                  <p>{steamUser ? `✅ ${steamUser.username}` : "❌ Ikke forbundet"}</p>
                </div>
              )}
            </div>

            <div className="terms-box">
              <label className="terms-check">
                <input
                  type="checkbox"
                  checked={acceptTerms}
                  onChange={(e) => setAcceptTerms(e.target.checked)}
                />
                <span>Jeg accepterer <a href="/vilkaar" target="_blank" rel="noreferrer">vilkår og betingelser</a></span>
              </label>
              <label className="terms-check">
                <input
                  type="checkbox"
                  checked={confirmAge}
                  onChange={(e) => setConfirmAge(e.target.checked)}
                />
                <span>Jeg bekræfter at mine aldersoplysninger er korrekte</span>
              </label>
            </div>

            {message && <p className="message">{message}</p>}
            {personalId && <p className="personal-id">Dit ID: <strong>{personalId}</strong></p>}

            {signupSuccess && (
              <a
                href="https://discord.com/invite/cWUtWdThXu"
                target="_blank"
                rel="noreferrer"
                className="btn-discord connected"
              >
                Gå til Discord →
              </a>
            )}
          </div>
        );

      default:
        return null;
    }
  };

  const isLastStep  = step === (under18 ? 5 : 4);
  const isFirstStep = step === 1;

  const canGoNext = () => {
    if (step === 1 && !isAuthenticated) return false;
    if (cs2MissingSteam) return false;
    return true;
  };

  const canSubmit = () => {
    if (!isAuthenticated) return false;
    if (!acceptTerms || !confirmAge) return false;
    if (isCS2(form) && !steamUser) return false;
    return true;
  };

  return (
    <div className="signup-page">

      {/* Progress bar */}
      <div className="steps-bar">
        {effectiveSteps.map((s) => (
          <div
            key={s.number}
            className={`step-dot ${step === s.number ? "active" : step > s.number ? "done" : ""}`}
          >
            <div className="dot">{step > s.number ? "✓" : s.number}</div>
            <span>{s.label}</span>
          </div>
        ))}
        <div className="steps-line">
          <div
            className="steps-line-fill"
            style={{ width: `${((step - 1) / ((under18 ? 5 : 4) - 1)) * 100}%` }}
          />
        </div>
      </div>

      {/* Step indhold */}
      <form
        onSubmit={isLastStep ? handleSubmit : (e) => e.preventDefault()}
        className="signup-form"
      >
        <div className="step-wrapper">
          {getStepContent()}
        </div>

        {/* Navigation */}
        <div className="step-nav">
          {!isFirstStep && (
            <button type="button" className="btn-prev" onClick={prev}>
              ← Tilbage
            </button>
          )}
          {!isLastStep ? (
            <button
              type="button"
              className="btn-next"
              onClick={next}
              disabled={!canGoNext()}
              title={cs2MissingSteam ? "CS2 kræver Steam login" : ""}
            >
              Næste →
            </button>
          ) : (
            <button
              type="submit"
              className="btn-submit"
              disabled={!canSubmit()}
            >
              Send tilmelding
            </button>
          )}
        </div>

        {cs2MissingSteam && (
          <p className="hint" style={{ textAlign: "center", marginTop: 8, color: "#f59e0b" }}>
            ⚠️ Log ind med Steam for at fortsætte med CS2
          </p>
        )}
      </form>

    </div>
  );
};

export default SignupAcademy;